<template>
<div>
    <el-drawer
        title="设置消息内容"
        :visible.sync="drawerShow"
        :wrapperClosable="false"
        :destroy-on-close="true"
        append-to-body
        size="500px"
        @close="close"
    >
        <div class="drawer-content" v-loading="dataLoading">
            <el-form :model="formData" ref="formData" label-position="top" size="medium" :rules="rules">                
                <el-form-item label="待推送演出:">
                    <span v-if="idOne"> {{idOne}} {{nameOne}}</span>
					<div v-if="list">
						<div v-for="(item,index) in list" :key="index" >{{item.activityId}} {{item.activityName}}</div>
					</div>
                </el-form-item>
				<el-form-item>
					<div class="title">推送策略：</div>
					<el-form-item prop="isDelay" label="推送时间：" class="ML20">					    
						<el-radio-group v-model="formData.isDelay">
						    <el-radio :label="0">立即推送：适用于需要紧急抢票的场景，不耽误用户抢票时机</el-radio><br>
							<el-radio :label="1" class="MT15">延迟推送：按用户自身活跃时间段分批次推送，降低打扰几率</el-radio>
						</el-radio-group>
					</el-form-item>
					<el-form-item prop="distance" label="推送距离：" class="ML20 MT20">					   
						<el-radio-group v-model="distance" @change="changeDistance()">
						    <el-radio :label="1">不限推送距离：推送给所有关注了艺人的粉丝</el-radio><br>
							<el-radio :label="2" class="MT15">限制推送距离：手动指定艺人粉丝所在的城市</el-radio>
						</el-radio-group>
					</el-form-item>
				</el-form-item>
				<!-- <el-form-item prop="cityCodes" v-if="distance == 2" class="ML20">
				    <span slot="label">地区设置:<small>（默认展示的是演出所在地周边500公里范围内的城市）</small></span>
				    <div v-if="cityListArr" >						
						<el-tag
						  class="MR10"
						  size="medium"
						  v-for="tag in cityListArr"
						  :key="tag.cityName"
						  closable
						  :disable-transitions="false"
						  @close="handleClose(tag.cityId)"
						  type="info">
						  {{tag.cityName}}
						</el-tag>
						<div class="MT20">
							<el-select v-model="cityIds" filterable clearable  placeholder="新增城市" size="small" :loading="cityLoading" ref="optionRefs" style="width: 80%; margin-right: 20px;">
							    <el-option
							        v-for="item in cityList"
							        :key="item.code"
							        :label="item.name"
							        :value="item.code">
							    </el-option>
							</el-select>
							<el-button type="primary" @click="addUser()" size="mini" >确定</el-button>
						</div>
					</div>
				</el-form-item> -->
				<el-form-item prop="sellArea" v-if="distance == 2" class="ML20">
				    <span slot="label">地区设置:<small>（默认展示的是演出所在地周边500公里范围内的城市）</small></span>
				    <el-cascader v-model="formData.sellArea" :options="cityList" filterable
				        :props="{ label: 'name', children: 'cityList', value: 'id', multiple: true, checkStrictly: true }"
				        style="width:100%" ref="cityCascader">
				    </el-cascader>
				</el-form-item>
                <el-form-item prop="content" label="消息内容:">
                    <el-input v-model="formData.content" placeholder="请填写消息内容" :minlength="200" type="textarea"></el-input>
                </el-form-item>
            </el-form>
        </div>
        <div class="drawer-footer">            
            <el-button @click="close()">关闭</el-button>
			<el-button type="primary" @click="submitForm()" :loading="btnLoading">确定</el-button>
        </div>
    </el-drawer>
   
</div>
</template>
<script>
import { fetchAllCity } from '@/assets/js/commonApi'
export default {
    components:{},
	props: {	   
	},
    data(){
        return{
            drawerShow: false,
            dataLoading: false,
            applyId: "",
            data: null,
			list:null,
            showViewer: false,
            btnLoading: false,
			idOne:'',
			nameOne:'',			
			formData:{
				content:'',
				isDelay:0,
				cityCodes:[],
				sellArea:[],
				provinceCodes:[]
			},
			rules: {
			    content: [{ required: true, message: "请填写消息内容" }],	
				sellArea: [{ required: true, message: "地区不能为空" }],	
			},
			cityList: [],			
			distance:1,			
			
			
			
        }
    },
    computed:{
        
       
    },
    methods:{
        close(){
           this.formData.content = ''
		   this.formData.sellArea = []
           this.drawerShow = false;
		   this.formData.isDelay = 0
		   this.distance = 1
		   
		  
        },
        show(id,name,list){
			this.idOne = id
			this.nameOne = name
			this.list = list			
            this.drawerShow = true;
			this.getCityList()
        },        
		submitForm(){
			this.$refs["formData"].validate((valid) => {
				if (valid) {
					if( this.idOne != '' ){
						this.pushAction()
					}else{
						this.aggregatePushAction()
					}
				}else{
					return;
				}
			})
		},
		
		//获取城市列表
		getCityListNear() {			
		    this.$request({
		    	url: "/common/getNearbyCity",
		    	method: "POST",
		    	params: {
		    		activityId:this.idOne
		    	},
		    })
		    .then((res) => {
		    	const { state, msg, result} = res.data;
		    	if ( state == 1) {		    		
					if( result ){						
						this.formData.sellArea = result
					}					
					
		    	} else {		    		
		    		this.$message.error(msg || "请求失败");
		    	}
		    })
		    .catch(() => {
		    	this.$message.error("请求错误");
		    })
		},
		//获取城市列表
		async getCityList() {
		    const res = await fetchAllCity({}).catch(() => { });
		    const { state, result } = res.data;
		    if (state == 1) {
		        this.cityList = result;
		    }
		},
		changeDistance(){			
			if( this.distance == 2 && this.list.length < 2){			
				this.getCityListNear()				
			}
		},
		
		pushAction(){			
			this.formData.provinceCodes = [];
			this.formData.cityCodes = [];
			
			this.formData.sellArea.map(item => {
			    if (!this.formData.provinceCodes.find(v => v == item[0]) && !item[1]) {
			        this.formData.provinceCodes.push(item[0]);
			    }
			    item[1] && this.formData.cityCodes.push(item[1]);
			})		
			
			//return
			this.btnLoading = true			
			this.$request({
				url: "/activityPush/push",
				method: "POST",
				params: {
					activityId: this.idOne,
					content:this.formData.content,
					isDelay:this.formData.isDelay,
					cityCodes:this.distance == 2 ? this.formData.cityCodes.join(',') : '',
					provinceCodes:this.distance == 2 ? this.formData.provinceCodes.join(',') : ''
				},
			})
			.then((res) => {
				const { state, msg } = res.data;
				if ( state == 1) {
					this.btnLoading = false;
					this.$emit('onUpdate');
					this.close()
				} else {
					this.btnLoading = false;
					this.$message.error(msg || "请求失败");
				}
			})
			.catch(() => {
				this.$message.error("请求错误");
			})
		},
        aggregatePushAction(){
			this.btnLoading = true			
            this.$request({
                url: "/activityPush/aggregatePush",
                method: "POST",
                params: {
                    activityIds: (this.list.map( v => v.activityId)).toString(),
        			content:this.formData.content
                },
            })
            .then((res) => {
                const { state, msg } = res.data;
                if ( state == 1) {
					this.btnLoading = false;
                    this.$emit('onUpdate');
					this.close()
                } else {
					this.btnLoading = false;
                    this.$message.error(msg || "请求失败");
                }
            })
            .catch(() => {
                this.$message.error("请求错误");
            })
        },
    }
}
</script>

<style lang="scss" scoped>
.button-new-tag {
    margin-left: 10px;
    height: 32px;
    line-height: 30px;
    padding-top: 0;
    padding-bottom: 0;
  }
  .input-new-tag {
    width: 90px;
    margin-left: 10px;
    vertical-align: bottom;
  }
</style>